module.exports = __webpack_public_path__ + "static/media/IMG_4013.a5d50842.jpg";